export const dataItem = [
  { text: "None", filter: "" },
  { text: "Category", filter: "category" },
  { text: "Developer", filter: "developer" },
  { text: "Installs", filter: "download" },
  //{ text: "Onboarding", filter: "onboarding_step_group" },
  { text: "Paywall Type", filter: "paywall_type" },
  { text: "Revenue", filter: "revenue" },
];
